import React, { useState } from 'react'
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


export default function PolicyEditor(props) {
    return (
        <div className='' >
            <Editor
                wrapperClassName="editor-wrapper-class"
                editorClassName="editor-class"
                editorState={props.editorState}
                onEditorStateChange={(e) => props.onEditorStateChange(e)}
                toolbarHidden={props.toolbarHidden !== undefined ? props.toolbarHidden : true}
                toolbar={props.toolbar}
            />
        </div>
    )
}
